<template>
  <div
      v-if="countdown"
      class="countdown-box"
      :class="{ compact: competition_list }"
  >
    <div class="countdown-labels">
      <div>DAYS</div>
      <div>HRS</div>
      <div>MIN</div>
      <div>SEC</div>
    </div>
    <div class="countdown-values">
      <div>{{ countdown.days }}</div>
      <div>{{ countdown.hours }}</div>
      <div>{{ countdown.minutes }}</div>
      <div>{{ countdown.seconds }}</div>
    </div>
  </div>
</template>


<script>
import { parseCompetitionDate, normalizeTimezoneInput } from '@/helpers/timezoneDate';

export default {
  name: "CountDown",
  props: {
    competition_date: {
      type: [String, null],
      required: true,
    },
    competition_timezone: {
      type: [String, Array, Object],
      default: null,
    },
    competition_list: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['time-reached'],
  data() {
    return {
      countdown: {days: 0, hours: 0, minutes: 0, seconds: 0},
      intervalId: null,
    };
  },
  watch: {
    competition_date: {
      immediate: true,
      handler(newVal) {
        this.resetCountdown(newVal);
      },
    },
    competition_timezone() {
      this.resetCountdown(this.competition_date);
    },
  },
  beforeUnmount() {
    if (this.intervalId) clearInterval(this.intervalId);
  },
  methods: {
    resetCountdown(rawDate) {
      if (this.intervalId) clearInterval(this.intervalId);

      if (!rawDate) {
        this.countdown = {days: 0, hours: 0, minutes: 0, seconds: 0};
        return;
      }

      const parsedDate = this.resolveTargetDate(rawDate);
      if (!(parsedDate instanceof Date) || isNaN(parsedDate.getTime())) {
        console.warn("Fecha inválida:", rawDate);
        this.countdown = {days: 0, hours: 0, minutes: 0, seconds: 0};
        return;
      }

      const update = () => {
        const now = new Date();
        const diff = parsedDate - now;

        if (diff <= 0) {
          clearInterval(this.intervalId);
          this.countdown = { days: 0, hours: 0, minutes: 0, seconds: 0 };
          this.$emit('time-reached'); // 👈 notificar al padre
          return;
        }

        const totalSeconds = Math.floor(diff / 1000);
        const days = Math.floor(totalSeconds / (3600 * 24));
        const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        this.countdown = {days, hours, minutes, seconds};
      };

      update();
      this.intervalId = setInterval(update, 1000);
    },
    resolveTargetDate(rawDate) {
      return parseCompetitionDate(rawDate, this.competition_timezone);
    },
    normalizeTimezoneInput(value) {
      return normalizeTimezoneInput(value);
    },
  },
};
</script>

<style scoped>
/* === ESTILO POR DEFECTO - DESKTOP === */
.countdown-box {
  font-family: 'VT323', monospace;
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 8px 10px;
  border-radius: 20px;
  font-size: 24px;
  display: flex;
  flex-direction: column;
  gap: 0;
  text-align: center;
  backdrop-filter: blur(2px);
  min-width: 180px;
}

.countdown-labels,
.countdown-values {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
}

.countdown-labels div {
  font-size: 14px;
  color: #ccc;
  font-weight: bold;
}

.countdown-values div {
  font-size: 28px;
  background: rgba(255, 255, 255, 0.1);
  padding: 2px 0;
  border-radius: 6px;
}

/* === ESTILO COMPACTO - DESKTOP === */
.countdown-box.compact {
  position: static;
  transform: none;
  font-size: 16px;
  padding: 6px;
  border-radius: 12px;
  min-width: 120px;
  background-color: rgba(0, 0, 0, 0.4);
}

.countdown-box.compact .countdown-labels div {
  font-size: 11px;
}

.countdown-box.compact .countdown-values div {
  font-size: 18px;
  padding: 3px 0;
}

/* === MOBILE === */
@media (max-width: 576px) {
  .countdown-box {
    bottom: 10px;
    left: 50%;
    padding: 10px 15px;
    font-size: 14px;
    min-width: 120px;
  }
  .countdown-labels {
    width: 100%;
    justify-items: center;
    align-items: center;
    text-align: center;
  }
  .countdown-labels div {
    font-size: 10px;
  }
  .countdown-values div {
    font-size: 12px;
    padding: 2px 0;
  }

  .countdown-box.compact {
    padding: 3px 7px;
    font-size: 13px;
    max-width: 100px;
  }
  .countdown-box.compact .countdown-labels div {
    font-size: 9px;
  }
  .countdown-box.compact .countdown-values div {
    font-size: 11px;
    padding: 2px 0;
  }
}
</style>
